import IAction from '../interfaces/action';
import IActionCreators from '../interfaces/actionCreators';

export const actions = {
    setAllNotes: 'SET_ALL_NOTES',
    setSelectedPageId: 'SET_SELECTED_PAGE_ID',
    setNoSearchHits: 'SET_NO_SEARCH_HITS',
    setSelectedNotes: 'SET_SELECTED_NOTES',
    setDisplayNoteId: 'SET_DISPLAY_NOTE_ID',

}

export const actionCreators: IActionCreators = {
    setDisplayNoteId: (id) => {
        return { type: actions.setDisplayNoteId, payload: id }
    },
    setNoSearchHits: (hasNoSearchHits: boolean) => {
        return { type: actions.setNoSearchHits, payload: hasNoSearchHits}
    },
    setSelectedNotes: (id: string) => {
        return { type: actions.setSelectedNotes, payload: id }
    },
    setAllNotes: (notes: any[]): IAction => {
        return { type: actions.setAllNotes, payload: notes };
    },
     setSelectedPageId: (number): IAction => {
        return { type: actions.setSelectedPageId, payload: number };
    },
}